import { Application } from "@hotwired/stimulus"

const application = Application.start()
import WebauthnController from "topsail_webauthn/app/javascript/controllers/webauthn_controller"
  application.register("webauthn", WebauthnController)
